// Company Profile Store

export interface CompanyProfile {
  nama: string;
  alamat: string;
  noTel: string;
  email: string;
  noPendaftaran: string;
  namaOwner: string;
  logo: string; // base64 or URL
}

const DEFAULT_COMPANY = {
  nama: 'SAP Ngecat',
  alamat: 'Jalan Perdagangan No. 123, Kuala Lumpur',
  noTel: '03-1234-5678',
  email: 'info@sapngecat.com',
  noPendaftaran: 'SA0601971-K',
  namaOwner: 'Khairul Anuar',
  logo: '',
};

// Terjemahan Bahasa Melayu
export const translations = {
  ms: {
    nama: 'Nama',
    alamat: 'Alamat',
    noTel: 'No. Telepon',
    email: 'Email',
    noPendaftaran: 'No. Pendaftaran',
    namaOwner: 'Nama Pemilik',
    logo: 'Logo',
  }
};

const STORAGE_KEY = 'sap_company_profile';

export const CompanyStore = {
  getCompany: (): CompanyProfile => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : DEFAULT_COMPANY;
  },

  saveCompany: (company: CompanyProfile) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(company));
  },

  reset: () => {
    localStorage.removeItem(STORAGE_KEY);
  },
};